<template>
  <Popup :title="title" @approve="handleApprove">
    <FormList
      v-model="value"
      :list="list"
      :additionalList="additionalList"
      :additionalListEnabled="showAdditionalListToggle"
    />
  </Popup>
</template>

<script>
import types from '../../config/types.js'
import Popup from '../../components/Popup.vue'
import FormList from '../../components/Form/PopupList.vue'
import ServiceData from '../../mixins/ServiceData.js'

export default {
  name: 'Server',
  components: { Popup, FormList },
  mixins: [ServiceData],
  data() {
    return {
      serverTypes: [],
    }
  },
  props: {
    modelValue: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
      default: types.serverModes.add,
    },
  },
  mounted() {
    this.serverService
      .getServerTypes()
      .then(response => {
        this.serverTypes = response.data
        if (this.modelValue.stuid) {
          const serverType = response.data.find(
            t => t.stuid === this.modelValue.stuid
          )
          if (serverType) {
            this.$emit('update:modelValue', {
              ...this.modelValue,
              is_ble: serverType.is_ble ?? false,
            })
          }
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    validate() {
      const data = this.value

      if (!data.host || !data.stuid) {
        return false
      }

      if (this.isSigur) {
        return true
      }

      return data.login && data.password
    },

    handleApprove() {
      if (this.validate()) {
        this.$emit('approve', this.value)
      } else {
        this.$store.dispatch('setNotification', {
          text: 'Заполните все обязательные поля',
          type: 'cross-outlined',
        })
      }
    },
  },
  computed: {
    title() {
      if (this.mode === types.serverModes.add) return 'Добавить сервер'
      if (this.mode === types.serverModes.edit) return 'Редактировать сервер'
      return 'Сервер'
    },
    isEditing() {
      return this.mode === types.serverModes.edit
    },

    selectedServerType() {
      if (!this.modelValue.stuid || this.serverTypes.length === 0) {
        return null
      }
      return this.serverTypes.find(type => type.stuid === this.modelValue.stuid)
    },

    selectedServerTypeName() {
      return this.selectedServerType ? this.selectedServerType.name : ''
    },

    isSigur() {
      return this.selectedServerTypeName === 'Sigur'
    },
    isBaseIp() {
      return this.selectedServerTypeName === 'BasIp'
    },
    isControlGate() {
      return this.selectedServerTypeName === 'ControlGate'
    },

    showAdditionalListToggle() {
      return this.isSigur
    },

    serverTypeLabels() {
      return this.serverTypes.map(type => ({
        id: type.stuid,
        label: type.is_ble ? `${type.name} (BLE сервер)` : type.name,
      }))
    },

    value: {
      get() {
        const currentValue = { ...this.modelValue }

        return currentValue
      },
      set(value) {
        const newValue = { ...value }

        const serverType = this.serverTypes.find(
          t => t.stuid === newValue.stuid
        )
        newValue.is_ble = serverType?.is_ble ?? false

        if (this.isSigur && newValue.proxy_host) {
          newValue.proxy_login = 'sigur'
          newValue.proxy_password = 'password'
        } else {
          newValue.proxy_host = null
          newValue.proxy_login = null
          newValue.proxy_password = null
        }

        this.$emit('update:modelValue', newValue)
      },
    },

    list() {
      const baseFields = [
        {
          id: 'host',
          label: 'Имя сервера (хост)',
          type: types.components.input,
          required: true,
          width: 12,
          attr: {
            placeholder: 'myserver.com',
          },
        },
        {
          id: 'stuid',
          label: 'Провайдер СКУД',
          required: true,
          type: types.components.select,
          width: 12,
          attr: {
            placeholder: 'Провайдер СКУД',
            options: this.serverTypeLabels,
          },
        },
        {
          id: 'is_ble',
          label: 'BLE сервер',
          type: types.components.checkbox,
          required: false,
          width: 12,
          attr: {
            disabled: true,
          },
        },
        {
          id: 'login',
          label: 'Логин',
          type: types.components.input,
          required: true,
          width: 12,
          attr: {
            placeholder: 'Логин',
          },
        },
        {
          id: 'password',
          label: 'Пароль',
          type: types.components.input,
          required: true,
          width: 12,
          attr: {
            placeholder: 'Пароль',
          },
        },
      ]

      // if (!this.isSigur) {
      //   baseFields.push(
      //       {
      //         id: "login",
      //         label: "Логин",
      //         type: types.components.input,
      //         required: true,
      //         width: 12,
      //         attr: {
      //           placeholder: "Логин",
      //         },
      //       },
      //       {
      //         id: "password",
      //         label: "Пароль",
      //         type: types.components.input,
      //         required: true,
      //         width: 12,
      //         attr: {
      //           placeholder: "Пароль",
      //         },
      //       }
      //   );
      // }

      return baseFields
    },

    additionalList() {
      if (!this.isSigur) {
        return []
      }

      return [
        {
          id: 'proxy_host',
          label: 'Имя прокси сервера (прокси хост)',
          type: types.components.input,
          required: false,
          width: 12,
          attr: {
            placeholder: 'Прокси сервер',
          },
        },
        // {
        //   id: 'proxy_login',
        //   label: 'Логин прокси сервера',
        //   type: types.components.input,
        //   required: false,
        //   width: 12,
        //   attr: {
        //     placeholder: 'Логин',
        //   },
        // },
        // {
        //   id: 'proxy_password',
        //   label: 'Пароль прокси сервера',
        //   type: types.components.input,
        //   required: false,
        //   width: 12,
        //   attr: {
        //     placeholder: 'Пароль',
        //   },
        // },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>
